import React from 'react';
import './App.css';
import SaaSKPIInterface from './SaaSKPIInterface';

function App() {
  return (
    <div className="App">
      <SaaSKPIInterface />
    </div>
  );
}

export default App;